import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchUnbookReasons = ({ accountId }) => get(`/accounts/${accountId}/unbook-reasons`);

export const addUnbookReason = ({ accountId, name, description, countAsNoShow }) =>
  post(`/accounts/${accountId}/unbook-reasons`, { name, description, countAsNoShow });

export const updateUnbookReason = ({ accountId, unbookReasonId, description }) =>
  patch(`/accounts/${accountId}/unbook-reasons/${unbookReasonId}`, { description });

export const deleteUnbookReason = ({ accountId, unbookReasonId }) =>
  httpDelete(`/accounts/${accountId}/unbook-reasons/${unbookReasonId}`);
